import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey);

export const db = {
  auth: {
    login: async (email, password) => {
      try {
        // First, sign in with Supabase auth
        const { data: authData, error: authError } = await supabase.auth.signInWithPassword({
          email,
          password,
        });

        if (authError) throw authError;

        if (!authData.user) {
          throw new Error('Authentication failed');
        }

        // Then get the profile data
        const { data: profile, error: profileError } = await supabase
          .from('profiles')
          .select(`
            *,
            provider_profiles (*)
          `)
          .eq('user_id', authData.user.id)
          .single();

        if (profileError) {
          console.error('Profile error:', profileError);
          throw new Error('Failed to fetch profile data');
        }

        return {
          id: profile.user_id,
          email: profile.email,
          name: profile.name,
          role: profile.role,
          is_provider: profile.role === 'provider',
          providerProfile: profile.provider_profiles
        };
      } catch (error) {
        console.error('Login error:', error);
        throw error;
      }
    },

    signup: async (name, email, password) => {
      try {
        // Create auth user
        const { data: authData, error: authError } = await supabase.auth.signUp({
          email,
          password,
          options: {
            data: {
              name,
            },
          },
        });

        if (authError) throw authError;

        if (!authData.user) {
          throw new Error('Failed to create user');
        }

        // Create profile
        const { error: profileError } = await supabase
          .from('profiles')
          .insert({
            user_id: authData.user.id,
            name,
            email,
            role: 'user'
          });

        if (profileError) throw profileError;

        return authData.user;
      } catch (error) {
        console.error('Signup error:', error);
        throw error;
      }
    }
  }
};